import {
  Button,
  Container,
  Header,
  Select,
} from '@cloudscape-design/components';
import AddressDisplay from 'components/Orders/package/addressDisplay';
import { useShipping } from 'components/Orders/package/shippingProvider';
import PropTypes from 'prop-types';
import React from 'react';

export default function PackageInfo({ onNext }) {
  const {
    toAddress, setToAddress,
    selectedShipFor, setSelectedShipFor,
    isLoading,
    handleVerifyAddress,
  } = useShipping();

  return (
    <>
      <Container header={<Header>Shipping Address</Header>}>
        <AddressDisplay
          address={toAddress}
          onEdit={(address) => {
            setToAddress(address);
          }}
        />
      </Container>

      <Container header={<Header>Reason for Shipment</Header>}>
        <Select
          selectedOption={selectedShipFor}
          onChange={({ detail }) => setSelectedShipFor(detail.selectedOption)}
          options={[
            { label: 'Sample part', value: 'Sample part' },
            { label: 'Vendor shipment', value: 'Vendor shipment' },
            { label: 'Customer part (do not use unless absolutely necessary)', value: 'Customer part (ad-hoc)' },
            { label: 'Other', value: 'Other' },
          ]}
        />
      </Container>

      <div style={{ display: 'flex', gap: 16, justifyContent: 'flex-end' }}>
        <Button variant="primary" disabled={!selectedShipFor?.value} loading={isLoading} onClick={() => handleVerifyAddress({ onSuccess: onNext })}>Next</Button>
      </div>
    </>
  );
}
PackageInfo.propTypes = {
  onNext: PropTypes.func.isRequired,
};
